import React from "react";

export default function MicSvgIcon() {
  return (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#F65A5B"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15.8332 8.33301V9.99967C15.8332 11.5468 15.2186 13.0305 14.1246 14.1245C13.0307 15.2184 11.5469 15.833 9.99984 15.833M9.99984 15.833C8.45274 15.833 6.96901 15.2184 5.87505 14.1245C4.78109 13.0305 4.1665 11.5468 4.1665 9.99967V8.33301M9.99984 15.833V19.1663M6.6665 19.1663H13.3332M9.99984 0.833008C9.3368 0.833008 8.70091 1.0964 8.23207 1.56524C7.76323 2.03408 7.49984 2.66997 7.49984 3.33301V9.99967C7.49984 10.6627 7.76323 11.2986 8.23207 11.7674C8.70091 12.2363 9.3368 12.4997 9.99984 12.4997C10.6629 12.4997 11.2988 12.2363 11.7676 11.7674C12.2364 11.2986 12.4998 10.6627 12.4998 9.99967V3.33301C12.4998 2.66997 12.2364 2.03408 11.7676 1.56524C11.2988 1.0964 10.6629 0.833008 9.99984 0.833008Z"
      />
    </svg>
  );
}
